const settings = {
  setFonts:function(response) {
      let setFonts = [];
      response.forEach(function(v){
        for(var k in v.elements) {
            if(v.elements[k]["properties"]["fontFamily"]) {
                if(v.elements[k]["properties"]["fontFamily"] !== "") {
                    setFonts.push(v.elements[k]["properties"]["fontFamily"]);
                }
            }
            if(v.elements[k].viewType === "grid") {
                v.elements[k].items.forEach(function(val){
                    
                    for(var key in val) {
                        //console.log(key, val[key])
                        if(key !== "viewType" && key !== "properties" && key !== "gridId" && key !== "viewId") {
                            if(val[key]["properties"]["fontFamily"]) {
                                if(val[key]["properties"]["fontFamily"] !== "") {
                                    setFonts.push(val[key]["properties"]["fontFamily"]);
                                }
                            }
                        } 
                    }
                })
            }
        }
      })
    setFonts = [...new Set(setFonts)]
    setFonts = setFonts.map(function(v){
       return v.replace(/ /g,"+");
     }).join(":wght@400;600;700&family=");
     
    

    return `https://fonts.googleapis.com/css2?family=${setFonts}:wght@400;600;700&display=swap`;
        
  },
  cssFiles:[ 
    {
      id:"bootstrap",
      path:"https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
    },
    {
        id:"swiper-css",
        path:"https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css"
    },
    {
        id:"fontello",
        path:"https://media.mediadirhub.com/minify/css/fontello.css"
    },
    {
      id:"fontello",
      path:"https://media.mediadirhub.com/minify/css/appyslim.css"
    },
    {
        id:"header-css",
        path:"/css/headerLibrary.css"
    },
    {
      id:"pages-css",
      path:"/css/pages.css"
    } 
  ],
  jsFiles:[
    {
        id:"swiper-bundle",
        path:"https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js"
    }
  ]
}

const getHeader = function(pages) {
    return `
    <header class="shadow-sm" style="background: #0e1017; color: #fff;">
    <div class="container-fluid">
      <div class="row align-items-center py-2">
        
        <!-- Left Column: Logo + Title -->
        <div class="col-auto d-flex align-items-center">
          <img src="/images/logo.png" alt="Logo" class="me-2 rounded-circle" style="height:60px">
          <span class="fw-bold fs-4">Karma Trust</span>
        </div>

        <!-- Center Column: Navigation -->
        <div class="col text-center">
          <ul class="nav justify-content-end">
          ${

            pages.map(function(v){
              return `<li class="nav-item"><a class="nav-link" href="/${v.url}" style="color: #fff;">${v.name}</a></li>`;
            }).join("")
          }

          </ul>
        </div>

        <!-- Right Column: Icons + Button -->
        <div class="col-auto d-flex align-items-center">
          <div class="d-none">
          <a href="#" style="display: inline-block; width: 36px; height: 36px; margin: 0; padding: 0; text-align: center; background: #fff; line-height: 36px; border-radius: 100%; color: #000;"><i class="fa iconz-globe fs-5"></i></a>
          <a href="#" style="display: inline-block; width: 36px; height: 36px; margin: 0; padding: 0; text-align: center; background: #fff; line-height: 36px; border-radius: 100%; color: #000;"><i class="fa iconz-globe fs-5"></i></a>
          <a href="#" style="display: inline-block; width: 36px; height: 36px; margin: 0; padding: 0; text-align: center; background: #fff; line-height: 36px; border-radius: 100%; color: #000;"><i class="fa iconz-globe fs-5"></i></a>
          
          </div>
          <a href="#" class="btn btn-primary rounded-pill px-4 d-none">Get Started</a>
        </div>

      </div>
    </div>
  </header>
    `
}


const getFooter = function() {
    return `
<footer class="border-top mt-0" style="background: #0e1017; color: #fff;">
  <div class="container py-4">
    <div class="row align-items-center">
      <!-- Logo + Title -->
      <div class="col-md-3 text-center text-md-start mb-3 mb-md-0">
        <a href="#" class="d-flex align-items-center justify-content-center justify-content-md-start text-decoration-none" style="color: #fff;">
          <img src="/images/logo.png" alt="Logo" class="me-2 rounded-circle" style="height:60px">
          <span class="fw-bold fs-5">Karma Trust</span>
        </a>
      </div>

      <!-- Center Links -->
      <div class="col-md-6 mb-3 mb-md-0">
        <ul class="nav justify-content-center d-none">
          <li class="nav-item"><a href="#" class="nav-link px-2" style="color: #fff;">Home</a></li>
          <li class="nav-item"><a href="#" class="nav-link px-2" style="color: #fff;">About</a></li>
          <li class="nav-item"><a href="#" class="nav-link px-2" style="color: #fff;">Services</a></li>
          <li class="nav-item"><a href="#" class="nav-link px-2" style="color: #fff;">Contact</a></li>
        </ul>
      </div>

      <!-- SEO Icons -->
      <div class="col-md-3 text-center text-md-end">
        <a href="#" class="ms-1 me-1" style="display: inline-block; width: 36px; height: 36px; margin: 0; padding: 0; text-align: center; background: #fff; line-height: 36px; border-radius: 100%; color: #000;"><i class="fa iconz-globe fs-5"></i></a>
        <a href="#" class="ms-1 me-1" style="display: inline-block; width: 36px; height: 36px; margin: 0; padding: 0; text-align: center; background: #fff; line-height: 36px; border-radius: 100%; color: #000;"><i class="fa iconz-globe fs-5"></i></a>
        <a href="#" class="ms-1 me-1" style="display: inline-block; width: 36px; height: 36px; margin: 0; padding: 0; text-align: center; background: #fff; line-height: 36px; border-radius: 100%; color: #000;"><i class="fa iconz-globe fs-5"></i></a>
      </div>
    </div>

    <!-- Copyright -->
    <div class="row mt-3">
      <div class="col text-center">
        <small>© 2025 Karma Trust. All rights reserved.</small>
      </div>
    </div>
  </div>
</footer>
    `
}

/*
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>My Website</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" rel="stylesheet">
</head>
<body>
  
  
  

  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>
*/



export default function(data, pages){
    return `
    <!DOCTYPE html>
<html lang="en">
<head>
  <!-- Required meta tags -->
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">

  <!-- SEO Meta Tags -->
  <title>${data.title}</title>
  <meta name="description" content="${data.description}" />
  <meta name="keywords" content="${data.keywords}" />
  <meta name="author" content="Your Name">

  <!-- Open Graph / Social Media Tags -->
  <meta property="og:title" content="${data.title}">
  <meta property="og:description" content="${data.description}">
  <meta property="og:type" content="website">
  <meta property="og:url" content="https://example.com/">
  <meta property="og:image" content="https://example.com/sample-image.jpg">

  <!-- Favicon -->
  <link rel="icon" href="/assets/favicon.ico" type="image/x-icon">

  <link type="text/css" rel="stylesheet" href="${settings.setFonts(JSON.parse(data.data))}"/>
  

 ${

    settings.cssFiles.map(function(v){
        return `<link type="text/css" rel="stylesheet" href="${v.path}"/>`
    }).join("")
 }
  

  <!-- Custom CSS -->
  <style>
    body {
      background-color: #f8f9fa;
    }
    .hero {
      background: linear-gradient(90deg, #0d6efd, #6610f2);
      color: white;
      padding: 4rem 2rem;
      text-align: center;
      border-radius: 0 0 1rem 1rem;
    }
  </style>
</head>
<body>
${getHeader(pages)}


  
${data.html}

${getFooter()}

${

    settings.jsFiles.map(function(v){
        return `<script type="text/javascript" src="${v.path}"></script>`
    }).join("")
 }
</body>
</html>
    `

}

